import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/ttl/assets/styles/components/detail-center/comment_detail_dialog.scss'
import uploadpictures from '@/assets/images/icons/light/market_comment_post_icon_uploadpictures.png'
import followicon from '@/assets/images/icons/light/market_comment_icon_follow.png'
import like_normal from '@/assets/images/icons/light/market_comment_icon_like_normal.png'
import like_hit from '@/assets/images/icons/light/market_comment_icon_like_hit.png'
import comment_normal from '@/assets/images/icons/light/market_comment_icon_comment_normal.png'

import LoadingLayer from '@/components/Spinner/LoadingLayer';

import { userActions } from '@/actions/user';
import { Converter, formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import { forumActions } from '@/actions/forum/forum.actions';
import { LOADING_TYPE } from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';

class CommentDetailDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            PostsData: null,
            cid: null,
            load: true,
            replyName: null,
        }
    }
    render() {
        const { language ,style} = this.props
        const { load, replyName, PostsData } = this.state
        return (
            <div className='comment_detail_dialog'>
                <LoadingLayer load={load} type={LOADING_TYPE.SKELETON}  width={style.width}  height={style.height} children={style.loadstyle} />
                {PostsData &&  !load  && <div>
                    <div className='comment_detail_dialog_post'  onClick={()=> this.setState({cid:null,replyName:null})} >
                        <div className='cddp_info'>
                            <div className='cppd_info_head'>
                                <img src={uploadpictures} ></img>
                                <span>  名字  </span>
                                <span className='cppd_info_time'>
                                    {formatFunctions.dataFormat(Number(PostsData.created), dataType.LONG_DATE)}
                                </span>
                            </div>
                            <div className='cppd_info_follow'>
                                {  this.props?.userInfo?.id !==  PostsData?.account_id &&  (PostsData.following == "Y" ? <div className='cppd_info_follow_n' onClick={(e) => this.handleUnFollow(e)}  > {language.market_comment_followed} </div>
                                    : <div className='cppd_info_follow_y' onClick={(e) => this.handleFollow(e)} ><img src={followicon} /> <span>{language.market_comment_follow}</span></div>)}
                            </div>
                        </div>
                        <div className='cddp_content'>
                            <h2 className='cddp_content_title'>{PostsData?.title}</h2>
                            <div className='cddp_content_body'>{PostsData?.summary}</div>
                            <div className='cddp_content_img' >
                                {PostsData.attaches && PostsData.attaches.split(',').map((item, index) => {
                                    return (<img src={item} key={index} ></img>)
                                })}
                            </div>
                        </div>
                        <div className='cddp_three_even' >
                            <div className='cddp_three_even_like' onClick={this.handleLike} >
                                {PostsData.like == 'Y' ? <img src={like_hit} /> : <img src={like_normal} />}
                                <span style={{ color: PostsData.like == 'Y' ? '#1996e3' : '' }} > {PostsData.dlike_counts}</span>
                            </div>
                            <div className='cddp_three_even_comment'>
                                <img src={comment_normal} />
                                <span>{PostsData.comments_count} </span>
                            </div>
                        </div>
                    </div>
                    <div className='comment_detail_dialog_all_comment' >
                        <h3>{language.market_comment_all_comments}</h3>
                        <div className='comment_detail_dialog_reply_comment' >
                            {
                                PostsData?.data?.rows && PostsData.data.rows.map((item, index) => {
                                    if (item.pid_account_id) {
                                        return (
                                            <div className='cdd_single_reply'  key={index} >
                                                <span className='cdd_single_reply_account_nick'> {item.account_nick + ' '} </span>
                                                <span  className='cdd_single_reply_reply' >{language.market_comment_reply + ' '}</span>
                                                <span  className='cdd_single_reply_pid_account_nick'> {item.pid_account_nick + ':'} </span>
                                                <span className='cdd_single_reply_content' > {item.content}</span>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className='cdd_single_comment' key={index} >
                                                <span className='cdd_single_comment_name'>{item.account_nick}:<span className='cdd_single_comment_content'>{item.content}</span></span>
                                                <div className='cdd_single_comment_reply' onClick={() => this.handleReply(item)} > {language.market_comment_reply} </div>
                                            </div>
                                        )
                                    }

                                })
                            }
                        </div>
                    </div>
                    <div className='comment_detail_dialog_reply'>
                        <div className='comment_detail_dialog_send' >
                            <input placeholder={replyName ? language.market_comment_reply + ' ' + replyName : language.market_comment} ref={e => this.sendInputRef = e} maxlength={249}  ></input>
                            <div onClick={this.handleSendComment} >{language.market_comment_send} </div>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
    componentDidMount() {
        this.getPostDetail()
    }
    handleUnFollow = (e) => {
        e.stopPropagation()
        const { userInfo } = this.props;
        const { PostsData } = this.state
        const { id } = userInfo;
        const params = { id: id, follow_id: PostsData.account_id }
        // this.setState({load:true})
        PostsData.following = 'N'
        this.setState({PostsData})
        this.props.postUnsubscribeList(params, res => {
            if (res) {
                // this.getPostDetail()
                this.props.getPostList()
            }
        })
    }
    handleFollow = (e) => {
        e.stopPropagation(e)
        const { userInfo } = this.props;
        const { PostsData } = this.state
        const { id } = userInfo;
        const params = { id: id, follow_id: PostsData.account_id }
        // this.setState({load:true})
        PostsData.following = 'Y'
        this.setState({PostsData})
        this.props.postSubscribeList(params, res => {
            if (res) {
                // this.getPostDetail()
                this.props.getPostList()
            }
        })
    }
    handleReply = (item) => {
        this.setState({ cid: item.cid, replyName: item.account_nick })
    }
    handleSendComment = () => {
        const { cid, PostsData } = this.state
        if(!this.sendInputRef.value) return
        if (cid) {
            const params = {
                cid: cid,
                body: this.sendInputRef.value,
            }
            this.sendInputRef.value = ''
            // this.setState({ load: true })
            this.props.replyComment(params, res => {
                if (res) {
                    this.getPostDetail()
                    this.props.getPostList()
                    this.setState({ PostsData: Object.assign(PostsData, PostsData.comments_count += 1), load: false ,cid:null,replyName:null })
                }
            })
        } else {
            const params = {
                nid: this.props.PostsData.nid,
                body: this.sendInputRef.value
            }
            this.sendInputRef.value = ''
            // this.setState({ load: true })
            this.props.writeComment(params, res => {
                if (res) {
                    this.getPostDetail()
                    this.props.getPostList()
                }
            })
        }
    }
    handleLike = () => {
        let { PostsData } = this.state
        const params = {
            id: PostsData.nid,
            name: "node_posts_like",
            switch: PostsData.like === 'Y' ? 'N' : 'Y',
            versiontype: 'Services-Flag-Toggle-Version',
            versionnum: '1.1'
        }
        PostsData.like = params.switch
        if(PostsData.like === 'Y') PostsData.dlike_counts +=1
        else {PostsData.dlike_counts -=1}
        this.setState({PostsData})
        this.props.toggleFlag(params, res => {
            if (res.status === SERVICES_RESP.STATUS_OK) {
                // this.getPostDetail()
                this.props.getPostList()
                // this.setState({ PostsData }, () => { this.props.getPostList() })
            }
        })
    }
    getPostDetail = () => {
        const params = {
            // page:1,
            size:99,
            nid: this.props.PostsData.nid,
            versiontype: 'Services-Content-Comments-Version',
            versionnum: '1.1',
        }
        // this.setState({ load: true })
        this.props.getPostDetail(params, res => {
            if (res) {
                this.setState({ PostsData: res.result.rows[0], load: false }, () => {
                })
            }
        })
    }
}


export default connect((state) => ({
    language: state.app.language,
    userInfo: state.user.userInfo,
}), dispatch => ({
    // getCommentPostList: (p, c) => dispatch(userActions.getPostListAction(p, c)),
    writeComment: (p, res) => dispatch(forumActions.writeCommentAction(p, res)),
    replyComment: (p, c) => dispatch(userActions.getMarketCommentReplyAction(p, c)),
    toggleFlag: (p, res) => dispatch(forumActions.toggleFlagAction(p, res)),
    postSubscribeList: (p, c) => dispatch(userActions.postSubscribeAction(p, c)),
    postUnsubscribeList: (p, c) => dispatch(userActions.postUnsubscribeAction(p, c)),
    // getComments: (p, res) => dispatch(forumActions.getCommentsPerPostAction(p, res)),
    getPostDetail: (p, res) => dispatch(userActions.getMarketCommentPostDetailAction(p, res)),
}))(CommentDetailDialog)